<template>
  <div>

    <div style="padding-bottom:15px">
      <div class="header" style="padding:10; margin: 0px;float: left;">
        <h4><slot name="header"></slot><span style="inline"><slot name="subheader"></slot></span></h4>
        
      </div>
      <transition name="fade">
        <beat-loader v-if="isUpdating!==undefined&&!listIsUpdating" style="float:left;padding: 8px 0 0 10px;" color="blue" size="5px"></beat-loader>
        <!-- <moon-loader v-if="listIsUpdating!==undefined && listIsUpdating!==null && !listIsUpdating" style="float:left;padding: 4px;;vertical-align:middle" color="blue" size="22px"></moon-loader> -->
      </transition>
      <div style="clear: both;"></div>
    </div>

    <pulse-loader :loading="(list.length === 0)" color="blue" style="padding:20px;"></pulse-loader>
    
    <table :class="tableClass + ' table-striped'" v-if="list.length > 0">
      <thead>
        <tr>
          <th v-for="(value, index) in formattedTitles()" :key="value" align="center"
          @click='sortColumn(index)'>
            {{value}}
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Data Rows -->
        <tr v-for="(row, index) in formattedData" :key="index">
          <td v-for="key in listKeys" :key="key" align="right" class="selectable" >
            <!-- {{data}} -->
            <transition name="data" mode="out-in">
              <div :key="data">
                {{ formattedData[index][key] }}
              </div>
            </transition>
          </td>
        </tr>
        <!-- End Data Rows -->

        <!-- Totals Row -->
        <tr v-for="(row, index) in formattedTotals" :key="`total_${index}`">
          <td v-for="key in listKeys" :key="key" align="right" class="selectable" 
            
          >
            <!-- {{data}} -->
            <transition name="data" mode="out-in">
              <div v-if="formattedTotals[index][key] !== 'Invalid date'" >
                <strong>
                  {{ formattedTotals[index][key] }}
                </strong>
              </div>
              <div v-else >
                <strong>
                  {{ totals[index][key] }}
                </strong>
              </div>
            </transition>
          </td>
        </tr>
        <!-- End Totals Row -->

      </tbody>
    </table>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import FadeLoader from 'vue-spinner/src/FadeLoader.vue'
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
import BeatLoader from 'vue-spinner/src/BeatLoader.vue'
import tdf from '@/Utilities/TableDataFormatter.js'

export default {
  name: 'BasicTableComponent',
  components: { PulseLoader, FadeLoader, MoonLoader, BeatLoader },
  props: [
    'list', 
    'hideColumns', 
    'formatters', 
    'titles', 
    'isUpdating',
    'totals',
    'tableClass',
    'zeroStr',
  ],
  data: function(){
    return {
      localData: [],
      formattedData: [],
      formattedTotals: {},
      sortedColumn: '',
      sortDirection: '',
      listIsUpdating: false
    }
  },
  created: function(){
    this.formatData();
  },
  watch:{
    'list':'formatData',
    'isUpdating': function (from, to) {
      this.listIsUpdating = to;
    }
  },
  computed:{
    listKeys(){
      let keys = this.$util.keys(this.list);
      // console.log('listKeys', this.columnOrder, keys)
      if(this.showColumns){
        keys = this.showColumns.filter(col => keys.includes(col));
      }
      if(this.columnOrder){
        const orderedColumns = [];
        this.columnOrder.forEach(key=>keys.includes(key) ? orderedColumns.push(key) : 1+1)
        keys.forEach(key=>!orderedColumns.includes(key) ? orderedColumns.push(key) : 1+1)
        return orderedColumns;
      } else {
        return keys;
      }
    },
    filteredList : function(){
      return this.list.map(row =>{
        if(this.hideColumns){
          this.hideColumns.forEach(col=>delete row[col])
        }
        return row
      })
    },
  },
  methods: {
    formatData: function(willOverwriteLocalData=true){
      this.listIsUpdating = false;
      if(willOverwriteLocalData){
        this.localData = this.filteredList;
      }
      this.formattedData = tdf.basicFormat(this.localData, this.convertedFormatters())
      // console.log('this.formattedData', this.formattedData)
      console.log('DEBUG', this.totals)
      if(this.totals){
        this.formattedTotals = tdf.basicFormat(this.totals, this.convertedFormatters(), this.zeroStr)
        console.log('DEBUG', this.totals, this.formattedTotals)
      } else {
        this.formattedTotals = [];
      }
    },
    convertedFormatters: function(){
      let result = {}
      if (this.formatters === undefined){
        return result;
      }
      Object.keys(this.formatters).forEach( key => {
        if(this.formatters[key].length === 1){
          result[key] = tdf[ this.formatters[key][0] ]();
          this.sortDirection = 'asc'
        } else {
          result[key] = tdf[ this.formatters[key][0] ]( this.formatters[key][1] );
          this.sortDirection = 'desc'
        }        
      })
      return result;
    },
    formattedTitles: function(){
      return tdf.columnFormatter(Object.keys(this.list[0]), this.titles)
    },
    sortColumn: function(index){
      let column = Object.keys(this.localData[index]);
      
      this.sortedColumn = column;
      if (this.sortedColumn === column){
        this.localData.sort((a,b)=>b[column].localeCompare(a[column]))
      } else {
        this.localData.sort((a,b)=>a[column].localeCompare(b[column]))
      }
      
      this.formatData(false);
    },
    sortColumnIcon: function(index){
      let column = Object.keys(this.localData[index]);
      return this.sortedColumn === column ? ` ${this.sortDirection}` : '';
    }
  },
}
</script>

<style>
.selectable {
    -webkit-touch-callout: all;
    -webkit-user-select: all;
    -khtml-user-select: all;
    -moz-user-select: all;
    -ms-user-select: all;
    user-select: all;
}

.header h1, .header h2, .header h3, .header h4 {
  margin:0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.fade-enter-active {
  transition: all .3s ease;
}
.fade-leave-active {
  transition: all 2.5s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.data-enter-active {
  transition: all 1.5s ease;
}
.data-enter {
  background:rgb(188, 232, 188);
}


</style>

